import React, { MouseEventHandler, useCallback } from 'react';
import { colors } from 'spw-theme';
import styled from 'styled-components';

const Container = styled.div`
  background-color: ${colors.white};
  border: 1px solid ${colors.veryLightGray};
  padding: 4px 8px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
  transition-duration: 0.5s;
  border-radius: 3px;
  width: fit-content;

  :hover {
    background-color: ${colors.grayLight};
  }

  &.main-blue {
    color: ${colors.mainBlue};
  }

  &.disabled {
    color: ${colors.mainGray};
    border: 1px solid ${colors.mainGray};
  }
`;

type Props = {
  color?: keyof Omit<typeof colors, 'floorPlan' | 'purples'>;
  onClick?: () => void;
  title?: string;
  dataTestId?: string;
  disabled?: boolean;
};

const ListActionButton = ({
  color,
  onClick,
  title,
  dataTestId,
  disabled,
}: Props) => {
  const handleClick = useCallback<MouseEventHandler>(
    (e) => {
      e.stopPropagation();
      if (onClick && !disabled) onClick();
    },
    [onClick, disabled]
  );

  return (
    <Container
      data-testid={dataTestId}
      onClick={handleClick}
      style={{ color: color && colors[color] }}
      className={disabled ? 'disabled' : ''}
    >
      {title}
    </Container>
  );
};

export default ListActionButton;
